import CancelablePromise from 'shared/src/modules/promise/CancelablePromise';
import { types } from "./types";

const fetchBusiness = (client, propertyId, businessId) => {
  const business = propertyId
    ? client
      .properties.for(propertyId)
      .businesses.for(businessId)
    : client
      .businesses.for(businessId);

  return business.detailsForAdmin();
};

let pending;

const businessMiddleware = client => store => next => async (action) => {
  const { type, payload } = action;
  const { businessId, propertyId } = payload || {};
  switch (type) {
    case types.BUSINESS_INVALIDATE:
      pending.cancel();
      pending = null;
      return next(action); // Let reducer handle it too
    case types.BUSINESS_DETAILS_REQUEST:
      // already loading for this action, ignore request
      if (pending?.action.payload.businessId === businessId) {
        return null;
      }

      // pending promise, not yet settled, cancel it
      if (pending && !pending.isSettled) {
        pending.cancel();
      }

      pending = new CancelablePromise(fetchBusiness(client, propertyId, businessId), action);

      return pending.promise.then((entity) => {
        store.dispatch({
          type: types.BUSINESS_DETAILS_SUCCESS,
          payload: {
            data: entity,
          }
        });
        return entity;
      }).catch((error) => {
        if (error.message === CancelablePromise.CANCELED) return null;

        if (pending.isCanceled === action) {
          return null;
        }

        store.dispatch({
          type: types.BUSINESS_DETAILS_FAILURE,
          error,
        });
        return error;
      });
    default:
      return next(action);
  }
};

export default businessMiddleware;
